import React, { useEffect, useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CustomMediaEchoRow from './customMediaEchoRow';
import CustomMediaEchoBuilder from './customMediaEchoBuilder';
import { getDuration } from '../../../../../redux/thunks/durationThunk';
import { getCampaignEchos } from '../../../../../redux/thunks/customMediaCampaignThunk';
import { CustomButton } from '../../../../shared';
import { PlusIcon } from '../../../../../assets';

function CustomMediaEchos(props) {
    const [createEcho, setCreateEcho] = useState(true);
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { campaign } = useSelector((state) => state.campaign);
    const { echos } = useSelector((state) => state.customMediaCampaign);

    useEffect(() => {
        dispatch(getDuration());
        dispatch(
            getCampaignEchos({
                companyId: company.id,
                campaignId: campaign.id,
            })
        );
    }, []);

    return (
        <Box>
            {echos.length > 0 && (
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Type</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {echos?.map((echo) => {
                                return (    
                                    <CustomMediaEchoRow
                                        key={'custom-media-echo-'+echo.id}
                                        id={echo.id}
                                        name={echo.name}
                                        imageUrl={echo.image_url}
                                        duration={echo.duration}
                                        type={echo.engagement_enabled?.toString()}
                                    />
                                );
                            })}
                        </TableBody>
                    </Table>
                </Paper>
            )}
            <Box className="pt-12px">
                {
                    !createEcho && (<Box className="border-1-gray-300 br-8px pt-12px">
                        <CustomMediaEchoBuilder handleAfterEchoSave={() => setCreateEcho(true)}/>
                    </Box>)
                }
                <Box className="pt-12px">
                    <CustomButton
                        title="Echo"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<PlusIcon color="#FFFFFF" />}
                        handleClick={() => setCreateEcho(false)}
                    />
               </Box>
            </Box>
        </Box>
    );
}

export default CustomMediaEchos;
